/**
 * Base64 → UTF-8 string decoder.
 *
 * `atob()` decodes Base64 to a Latin-1 binary string, NOT to a Unicode
 * string.  When the original data was encoded as UTF-8 (Arabic, CJK, emoji,
 * or any non-ASCII text) the result will be mojibake like "Ø³ØªÙ…".
 *
 * This helper converts the binary bytes produced by `atob()` through
 * `TextDecoder("utf-8")` to get the correct Unicode string.
 */
export function decodeBase64UTF8(base64: string): string {
  try {
    const binaryStr = atob(base64);
    const bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    return new TextDecoder("utf-8").decode(bytes);
  } catch {
    // Return the original value if the input is not valid Base64
    return base64;
  }
}
